import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import markerIcon from '../../../assets/icons/marker.svg';
import calendarIcon from '../../../assets/icons/calendar.svg';
import heartIcon from '../../../assets/icons/heart.svg';
import heartIconActive from '../../../assets/icons/bottomBar/active_heart.svg';
import placeholderImage from '../../../assets/images/noimage.png';

import { addToFavorites, removeFromFavorites } from "../../../api/favoritecall";
import { formatPrice } from '../../../utils/formatPrice';
import formatDate from '../../../utils/formatDate';

const CategoryAdItem = ({ item }) => {
    const [isFavorite, setIsFavorite] = useState(item.is_favorite || false);
    const navigate = useNavigate();

    useEffect(() => {
        setIsFavorite(item.is_favorite || false);
    }, [item.is_favorite]);

    const handleFavoriteToggle = async (e) => {
        e.stopPropagation();
        e.preventDefault();

        // Check authorization first - if not authorized, navigate to login page
        const accessToken = localStorage.getItem("access_token");
        if (!accessToken) {
            navigate('/sign');
            return;
        }

        try {
            if (isFavorite) {
                await removeFromFavorites(item.id);
                setIsFavorite(false);
            } else {
                await addToFavorites(item.id);
                setIsFavorite(true);
            }
        } catch (error) {
            console.error("Error toggling favorite:", error);
            // Revert to previous state on error
            setIsFavorite(!isFavorite);
        }
    };

    const handleClick = () => {
        navigate(`/announcement/${item.id}`);
    };

    const truncateTitle = (text, maxLength = 50) => {
        if (text && text.length > maxLength) {
            return text.substring(0, maxLength) + '...';
        }
        return text;
    };

    const hasLocation =
        (item.location && (item.location.province || item.location.locality)) ||
        false;

    return (
        <div className="cursor-pointer bg-white rounded-[10px] flex flex-col w-full text-left" onClick={handleClick}>
            <div className="relative">
                <img
                    className="cursor-pointer absolute right-5 top-5 md:right-[10px] md:top-[10px] bg-white p-[5px] rounded-full z-10"
                    src={isFavorite ? heartIconActive : heartIcon}
                    alt="like"
                    onClick={handleFavoriteToggle}
                />
                <img
                    className="w-full h-[280px] md:h-[150px] rounded-[10px] m-0 object-cover"
                    src={item.main_image_url || placeholderImage}
                    alt={item.title}
                    onError={(e) => {
                        if (e.target.src !== placeholderImage) {
                            e.target.onerror = null;
                            e.target.src = placeholderImage;
                        }
                    }}
                />
            </div>
            <div className="p-5">
                <h3 className="font-medium text-[#222222] text-base md:text-sm m-0 md:overflow-hidden md:text-ellipsis">{truncateTitle(item.title)}</h3>
                <div className="flex items-center gap-[10px] mt-2">
                    <p className="text-[#147F26] text-base font-bold">
                        {formatPrice(item.price, item.price_type, item.is_negotiable, item.barter)}
                    </p>
                </div>
                {hasLocation && (
                    <div className="flex items-center flex-row mt-2">
                        <img src={markerIcon} alt="location" className="w-[19px] hidden md:flex justify-start items-center flex-col" />
                        <div className="flex flex-col">
                            <p className="text-sm font-medium text-[#222222] m-[5px] md:m-0">
                                {item.location?.province && `${item.location.province}, `}
                                {item.location?.locality || ''}
                            </p>
                        </div>
                    </div>
                )}
                <div className="flex items-center flex-row mt-2">
                    <img src={calendarIcon} alt="calendar" className="w-[19px] hidden md:flex justify-start items-center flex-col" />
                    <p className="text-sm font-medium text-[#222222] m-[5px] md:m-0">
                        {formatDate(item.created_at)}
                    </p>
                </div>
            </div>
        </div>
    );
};

export default CategoryAdItem;